// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function EmailSubscription({ width = "59px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59 59"
      width={width}
      {...props}
    >
      <circle
        fill="#4f5565"
        cx="29.5"
        cy="29.5"
        r="29.5"
        transform="translate(0 0)"
      />
      <rect
        fill="#fbd303"
        width="46.037"
        height="29.736"
        transform="translate(6.481 23.726)"
      />
      <path
        fill="#f5ea0a"
        d="M101.984,326.571,78.966,308.9,55.947,326.571Z"
        transform="translate(-49.466 -273.11)"
      />
      <path
        fill="#f8b517"
        d="M78.966,47.809,55.947,66,78.966,84.144,101.984,66Z"
        transform="translate(-49.466 -42.27)"
      />
      <path
        fill="#fcfcfd"
        d="M144.969,91.189V70.527H111.894V91.189l16.537,13.041Z"
        transform="translate(-98.931 -62.357)"
      />
      <g transform="translate(17.676 13.198)">
        <rect fill="#dededf" width="18.03" height="2.043" />
        <rect
          fill="#dededf"
          width="23.254"
          height="2.043"
          transform="translate(0 5.539)"
        />
        <rect
          fill="#dededf"
          width="23.254"
          height="2.043"
          transform="translate(0 11.077)"
        />
        <rect
          fill="#dededf"
          width="23.254"
          height="2.043"
          transform="translate(0 16.616)"
        />
        <path
          fill="#dededf"
          d="M199.676,304.827H183.1l2.593,2.082h11.391Z"
          transform="translate(-179.564 -282.712)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/EmailSubscription.js